import { Link } from 'react-router-dom';
import { featuredAnime } from '@/mocks/animeData';

const seasonalCards = [
  {
    id: 'season-001',
    title: 'Re：从零开始的异世界生活 第三季',
    category: '异世界奇幻',
    rating: 9.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Fantasy%20isekai%20anime%20scene%20with%20dramatic%20magic%20effects%2C%20soft%20mint%20green%20and%20silver%20color%20palette%2C%20ethereal%20atmosphere%2C%20anime%20art%20style%2C%20beautiful%20character%20illustration&width=900&height=400&seq=season-card-01&orientation=landscape',
    linkTo: '/article/article-001',
  },
  {
    id: 'season-002',
    title: '无职转生 第三季',
    category: '异世界转生',
    rating: 9.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20anime%20scene%20with%20soft%20pink%20cherry%20blossoms%2C%20gentle%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20shojo%20anime%20art%20style%2C%20beautiful%20sunset%20lighting&width=900&height=400&seq=season-card-02&orientation=landscape',
    linkTo: '/article/article-002',
  },
];

export default function FeaturedGrid() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-900">
            热门<span className="text-primary-500">推荐</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-500">精心挑选的当季必看番剧，每一部都不容错过</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 md:gap-5">
          <div className="w-full lg:w-1/2" data-product-shop>
            <Link
              to="/article/article-004"
              className="group block relative w-full aspect-[4/5] lg:aspect-[3/4] rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Kimetsu%20no%20Yaiba%20anime%20style%20illustration%2C%20dramatic%20battle%20scene%20with%20flame%20and%20water%20effects%2C%20Japanese%20demon%20slayer%20aesthetic%2C%20dark%20atmospheric%20background%20with%20red%20and%20blue%20contrast%2C%20epic%20cinematic%20composition%2C%20high%20quality%20anime%20art&width=800&height=1100&seq=featured-large-kny&orientation=portrait"
                alt={featuredAnime.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-2">
                  {featuredAnime.status}
                </span>
                <h3 className="text-lg md:text-xl font-bold font-heading text-background-50">
                  {featuredAnime.title}
                </h3>
                <p className="mt-1 text-xs text-background-200 line-clamp-2">{featuredAnime.description}</p>
                <div className="flex items-center gap-3 mt-3">
                  <span className="flex items-center gap-1 text-xs text-accent-400">
                    <i className="ri-star-fill"></i>
                    {featuredAnime.rating}
                  </span>
                  <span className="text-xs text-background-300">{featuredAnime.episodeCount}话</span>
                </div>
              </div>
            </Link>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col gap-4 md:gap-5">
            {seasonalCards.map((anime) => (
              <Link
                key={anime.id}
                to={anime.linkTo}
                className="group block relative w-full aspect-[16/7] rounded-lg overflow-hidden cursor-pointer"
                data-product-shop
              >
                <img
                  src={anime.imageUrl}
                  alt={anime.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-4 md:p-5">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-500 text-background-50 text-xs font-medium mb-1.5">
                    {anime.category}
                  </span>
                  <h3 className="text-base md:text-lg font-bold font-heading text-background-50">{anime.title}</h3>
                  <div className="flex items-center gap-1 mt-1">
                    <i className="ri-star-fill text-accent-400 text-xs"></i>
                    <span className="text-xs text-accent-400">{anime.rating}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}